export default __webpack_public_path__ + "static/media/logo.ef9c76d7.png";